import { AxiosError } from 'axios';
import { useIntl } from 'react-intl';

import { ErrorCode, ErrorFormatter, LocaleKeyFormatter } from './types';
import { defaultFormatter } from './utils';
import { ExpectedError } from '../../../types';

export const useLocalizedExpectedError = <T extends ErrorCode>(
  toLocaleKey: LocaleKeyFormatter,
  error?: AxiosError<ExpectedError<T>> | null | unknown,
  formatter?: ErrorFormatter<T>,
) => {
  const { formatMessage } = useIntl();

  if (!error) return;

  if (error instanceof AxiosError && error.response) {
    if (error.response.status >= 500) {
      return formatMessage({ id: 'common.api_error:server_error' });
    }

    const message = (formatter ?? defaultFormatter(formatMessage))(error.response, toLocaleKey);

    if (message) {
      return message;
    }

    return error.message;
  }

  return formatMessage({ id: 'common.api_error:unknown_error' });
};
